module.exports = __webpack_public_path__ + "static/media/link.03dc327a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/link.png
// module id = 1537
// module chunks = 0